<template>
  <div class="sc-dv-title">
    <div class="title">
      <div class="logo" />
      <h1 v-if="title" :title="title">{{ title }}</h1>
      <h4 v-if="subTitle" :title="subTitle">{{ subTitle }}</h4>
    </div>
    <div class="adorn-top">
      <i v-for="i in 10" :key="i" />
    </div>
    <div class="adorn-wing adorn-wing-left" />
    <div class="adorn-wing adorn-wing-right" />
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    // 标题
    title: String,
    // 副标题
    subTitle: String,
  },
};
</script>

<style lang="scss" scoped>
.sc-dv-title {
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTA4OHB4IiBoZWlnaHQ9Ijg2cHgiIHZpZXdCb3g9IjAgMCAxMDg4IDg2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIwJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJsaW5lYXJHcmFkaWVudCI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMzRDM4N0QiIG9mZnNldD0iMC4wMjYzOTM1ODExJSI+PC9zdG9wPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNEVDQ0NFIiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU5My4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU5Ni42OTkyNDEsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50KSIgc3Ryb2tlLW9wYWNpdHk9IjAuMTk3NzQzNjYzIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTI5NC42NTM4MjcsNDQuMTA3NTYzMSBDMjkyLjYxMDY3MywzOC40Nzg0MDU0IDI5MC4yNDQwNiwzNS4yOTE3NjQ4IDI4Ny43NTg2NTEsMzQuNDAxODYyNyBDMjg1LjMxMzAxMSwzMy41MjYxOTk4IDI4Mi41NjY4MDUsMzMuMTM1OTE5NSAyNzguOTM1NDQ5LDMzLjAzNzQ2NTIgQzI3Ny43NzUxNzcsMzMuMDA2MDA3NiAyNzYuODMyMTE0LDMzLjAwMjk2OSAyNzQuNzM4MDc1LDMzLjAxMzA2MzYgQzI3NC4wMjM5MzEsMzMuMDE2NTA2MyAyNzMuNzE1NDMzLDMzLjAxNzcyMDIgMjczLjMyNDIxNywzMy4wMTgxOTQ1IEwxMi4wMTU3NjA0LDMzLjMzOTgwMjkgQzIuMzg4NDc2NjEsMzMuMzUxNDc0NCAtMi44MTQ0MzgzNywyNy44ODY1NTcyIC0xLjI1MjI5MjM4LDE4LjYwODM2ODMgQy0wLjQ5MjYzMDUxMywxNC4wOTY0NDI4IDQuMTk1MTI0MjQsNy41NTQzMzA2NCAxMi44NTQ3NDQ5LC0xLjM5MTA3MzI5IEwxMy40NDQyMTc5LC0yIEwxMDY3LjE1NzMsLTIgTDEwNjcuNzQ2NzcsLTEuMzkxMDczMjkgQzEwNzYuNDA2MzksNy41NTQzMzA2NCAxMDgxLjA5NDE1LDE0LjA5NjQ0MjggMTA4MS44NTM4MSwxOC42MDgzNjgzIEMxMDgzLjQxNTk2LDI3Ljg4NjU1NzIgMTA3OC4yMTMwNCwzMy4zNTE0NzQ0IDEwNjguNTg1NzIsMzMuMzM5ODAyOCBMODA3LjI3NzMzOSwzMy4wMTgxOTQ1IEM4MDYuODg2MDg1LDMzLjAxNzcyMDIgODA2LjU3NzU4OCwzMy4wMTY1MDYzIDgwNS44NjM0NDQsMzMuMDEzMDYzNiBDODAzLjc2OTQwNSwzMy4wMDI5NjkgODAyLjgyNjM0MiwzMy4wMDYwMDc2IDgwMS42NjYwNywzMy4wMzc0NjUyIEM3OTguMDM0NzE0LDMzLjEzNTkxOTUgNzk1LjI4ODUwOCwzMy41MjYxOTk4IDc5Mi44NDI4NjgsMzQuNDAxODYyNyBDNzkwLjM1NzQ1OCwzNS4yOTE3NjUgNzg3Ljk5MDg0NSwzOC40Nzg0MDY2IDc4NS45NDc2OTEsNDQuMTA3NTY2MyBMNzc2Ljg5MzQ3NSw3My44MjAwMzczIEM3NzUuOTA5OTczLDc2LjkzMjAyNzIgNzc0LjU1MTg3Miw3OS4zNzE0OTA5IDc3Mi43ODY0NCw4MS4xMTcxMTUyIEM3NzAuNzM1Mzk3LDgzLjE0NTE0NjggNzY2LjA3NDA5Nyw4My45NzIyNzY1IDc1OC4zODUyMjQsODQuMDAwODU5MiBMMzIyLjIxNjI5NSw4NC4wMDA4NTkyIEwzMjIuMjA4ODU3LDg0LjAwMDg0NTQgQzMxNC41Mjc0MjIsODMuOTcyMjc2NSAzMDkuODY2MTIxLDgzLjE0NTE0NjggMzA3LjgxNTA3OCw4MS4xMTcxMTUyIEMzMDYuMDQ5NjQ3LDc5LjM3MTQ5MDkgMzA0LjY5MTU0Niw3Ni45MzIwMjcyIDMwMy43MDE5MjYsNzMuODAwMzI4MyBMMjk0LjY1MzgyNyw0NC4xMDc1NjMxIFoiIC8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==')
    no-repeat center top;
  background-size: 100%;
  display: flex;
  height: 86px;
  position: relative;
  user-select: none;
  width: 1088px;

  // 标题
  .title {
    color: #fff;
    align-items: center;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    height: 70px;
    margin: 12px auto 0;
    padding: 0 48px;
    position: relative;
    text-align: center;
    width: 30%;

    h1,
    h4 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    h1 {
      font-size: 24px;
      font-weight: 500;
      line-height: 36px;
    }

    h4 {
      font-size: 12px;
      font-weight: normal;
      opacity: 0.5;
    }

    .logo {
      background: url('/images/2020/logo-white.svg') no-repeat center;
      background-size: 100% auto;
      height: 48px;
      left: 0;
      top: 50%;
      margin-top: -24px;
      position: absolute;
      width: 48px;
    }

    // 建筑物装饰
    &::after {
      content: '';
      background: url('/images/2020/adorn-yg-bild.svg') no-repeat center top;
      height: 60px;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 48px;
    }
  }

  // 顶部装饰
  .adorn-top {
    background-color: #10162e;
    border-radius: 0 0 8px 8px;
    align-items: center;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 0;
    height: 10px;
    width: 300px;

    i {
      background-color: #00fff5;
      border-radius: 50%;
      display: block;
      height: 4px;
      margin: 2px 4px;
      width: 4px;

      &:nth-child(1),
      &:nth-child(5),
      &:nth-child(8),
      &:nth-child(10),
      &:nth-child(15) {
        animation: adornTopDot 0.6s infinite;
      }

      &:nth-child(2),
      &:nth-child(4),
      &:nth-child(7),
      &:nth-child(13) {
        animation: adornTopDotB 1s infinite;
      }

      &:nth-child(3),
      &:nth-child(6),
      &:nth-child(9),
      &:nth-child(11),
      &:nth-child(14) &:nth-child(16) {
        animation: adornTopDotC 0.3s infinite;
      }
    }
  }

  // 侧翼
  .adorn-wing {
    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTU4cHgiIGhlaWdodD0iOHB4IiB2aWV3Qm94PSIwIDAgMTU4IDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU5LjEgKDg2MTQ0KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT7nlLvmnb88L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjEwMCUiIHkxPSI0OS44NzAwOTU0JSIgeDI9IjAlIiB5Mj0iNTAlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGRkZGRkYiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZGRkZGRiIgc3RvcC1vcGFjaXR5PSIwIiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPGcgaWQ9IueUu+advyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTE1NC40NzUyNDUsMCBMMTU4LjQ3NTI0NSw4IEwxNDYuNDc1MjQ1LDggTDE0Mi40NzUyNDUsMCBMMTU0LjQ3NTI0NSwwIFogTTEyOC40NzUyNDUsMCBMMTMyLjQ3NTI0NSw4IEwxMjAuNDc1MjQ1LDggTDExNi40NzUyNDUsMCBMMTI4LjQ3NTI0NSwwIFogTTEwMi40NzUyNDUsMCBMMTA2LjQ3NTI0NSw4IEw5NC40NzUyNDQ5LDggTDkwLjQ3NTI0NDksMCBMMTAyLjQ3NTI0NSwwIFogTTc2LjQ3NTI0NDksMCBMODAuNDc1MjQ0OSw4IEw2OC40NzUyNDQ5LDggTDY0LjQ3NTI0NDksMCBMNzYuNDc1MjQ0OSwwIFogTTUwLjQ3NTI0NDksMCBMNTQuNDc1MjQ0OSw4IEw0LjQ3NTI0NDkzLDggTDAuNDc1MjQ0OTI4LDAgTDUwLjQ3NTI0NDksMCBaIiBpZD0i5b2i54q257uT5ZCI5aSH5Lu9IiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTEpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS40NzUyNDUsIDQuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC03OS40NzUyNDUsIC00LjAwMDAwMCkgIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==')
      no-repeat left center;
    background-size: cover;
    height: 8px;
    position: absolute;
    top: 12px;
    width: 158px;

    &-left {
      left: 64px;
      transform: rotateY(180deg);
    }
    &-right {
      right: 64px;
    }
  }
}

// 顶部装饰点动态效果
@keyframes adornTopDot {
  50%,
  20%,
  30% {
    // color: red;
    opacity: 0.5;
  }
}
@keyframes adornTopDotB {
  30% {
    // color: red;
    opacity: 0.5;
  }
}
@keyframes adornTopDotC {
  65% {
    // color: red;
    opacity: 0.3;
  }
}
</style>
